import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { Button, ButtonProps } from "components/DesignSystem/Button/Button";
import { ArrowDown } from "components/icons/ArrowDown";
import { PlusIcon } from "components/icons/PlusIcon";
import { AddExisting as AddExistingIcon } from "components/icons/AddExisting";

type AddRegistrationDropdownProps = {
  onAddNew: () => void;
  onAddExisting: () => void;
  triggerCustomType?: ButtonProps["customType"];
};

export const AddRegistrationDropdown = ({
  onAddNew,
  onAddExisting,
  triggerCustomType = "primary",
}: AddRegistrationDropdownProps) => {
  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild className="t-group t-text-text-60">
        <Button size="small" customType={triggerCustomType}>
          Add registration
          <div className="group-data-state-open:-t-rotate-180 t-transform t-transition t-duration-300 t-ease-in-out t-text-surface">
            <ArrowDown color="currentColor" strokeWidth="1.5" />
          </div>
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content
          sideOffset={8}
          side="bottom"
          className="t-w-10"
          align="end"
        >
          <Dropdown.Item onSelect={onAddNew}>
            <div className="t-flex t-items-center t-gap-1">
              <PlusIcon size="12" />
              <div>Add new</div>
            </div>
          </Dropdown.Item>
          <Dropdown.Item onSelect={onAddExisting}>
            <div className="t-flex t-items-center t-gap-1">
              <AddExistingIcon />
              <div>Add existing</div>
            </div>
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
